import { NutritionalValueGroup } from './NutritionalValueGroup';

export type { TypeNutritionalValueGroupProps } from './types';
export default NutritionalValueGroup;
